var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAdvanceLending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.125,
    cy: 21,
    r: 21,
    fill: "#AF52DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9668 23.2755L26.7505 26.1738C26.307 26.7537 25.6187 27.0938 24.8887 27.0938H20.7734C20.4498 27.0938 20.1875 26.8315 20.1875 26.5079C20.1875 26.1843 20.4498 25.9219 20.7734 25.9219H24.3402C25.1068 25.9219 25.7488 25.2946 25.7341 24.5281C25.7199 23.7853 25.1134 23.1876 24.3672 23.1876H20.2656C19.088 22.0553 17.2707 21.9228 15.9413 22.8723L15.5 23.1876V29.8282H19.4062H20.1875H25.69C26.8863 29.8282 28.0004 29.2199 28.6473 28.2137L30.9339 24.6566C31.0587 24.4626 31.125 24.2368 31.125 24.0062C31.125 22.8559 29.6654 22.3618 28.9668 23.2755Z",
    fill: "#AF52DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7422 22.0156H11.7109C11.3873 22.0156 11.125 22.278 11.125 22.6016V30.4141C11.125 30.7377 11.3873 31 11.7109 31H13.7422C14.0658 31 14.3281 30.7377 14.3281 30.4141V22.6016C14.3281 22.278 14.0658 22.0156 13.7422 22.0156Z",
    fill: "#AF52DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.309 14.2383C22.1898 14.3297 22.1241 14.4681 22.1015 14.5881C22.0703 14.7537 22.1098 14.9075 22.2021 14.98C22.2347 15.0055 22.2705 15.0305 22.309 15.0552V14.2383Z",
    fill: "#AF52DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7266 20.7656C25.4189 20.7656 27.6094 18.5752 27.6094 15.8828C27.6094 13.1904 25.4189 11 22.7266 11C20.0342 11 17.8438 13.1904 17.8438 15.8828C17.8438 18.5752 20.0342 20.7656 22.7266 20.7656ZM21.2485 17.4793C21.3665 17.2988 21.6087 17.248 21.7892 17.3662C22.0002 17.5042 22.1324 17.5641 22.309 17.5889V15.9392C22.0595 15.8249 21.873 15.7148 21.72 15.5948C21.3958 15.3405 21.2478 14.8995 21.3337 14.4436C21.4273 13.9468 21.7731 13.5515 22.2361 13.412C22.2607 13.4046 22.2849 13.3979 22.309 13.3915V13.1484C22.309 12.9327 22.4839 12.7578 22.6996 12.7578C22.9153 12.7578 23.0902 12.9327 23.0902 13.1484V13.3487C23.4695 13.4144 23.7375 13.6011 23.8674 13.7501C24.0091 13.9128 23.9921 14.1595 23.8294 14.3012C23.6676 14.4421 23.4227 14.4261 23.2805 14.2659C23.2716 14.2568 23.2096 14.1971 23.0902 14.153V15.4152C23.1596 15.441 23.2289 15.4659 23.2969 15.49C23.9835 15.7327 24.3654 16.3684 24.2472 17.0717C24.1553 17.6184 23.7393 18.1728 23.0902 18.3374V18.6172C23.0902 18.8329 22.9153 19.0078 22.6996 19.0078C22.4839 19.0078 22.309 18.8329 22.309 18.6172V18.3749C21.9936 18.3477 21.7321 18.2625 21.3615 18.02C21.181 17.9019 21.1304 17.6598 21.2485 17.4793Z",
    fill: "#AF52DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4768 16.9421C23.5025 16.7894 23.513 16.4256 23.0902 16.2476V17.5023C23.3099 17.3764 23.4412 17.1538 23.4768 16.9421Z",
    fill: "#AF52DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11.125 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdvanceLending);
export default __webpack_public_path__ + "static/media/ic_advance_lending.ecf35a9637cc88b8f28ee9d09fabb509.svg";
export { ForwardRef as ReactComponent };